module.exports = __webpack_public_path__ + "static/media/7eff52d0.jpg";